import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmailTemplatePageRoutingModule } from './email-template-routing.module';

import { EmailTemplatePage } from './email-template.page';
import { DxDataGridModule } from 'devextreme-angular';
import { EmailServiceService } from './service/email-service.service';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		EmailTemplatePageRoutingModule,
		DxDataGridModule,
	],
	declarations: [EmailTemplatePage],
	providers: [EmailServiceService],
})
export class EmailTemplatePageModule {}
